<template><article><h1>Range mode</h1>
<p>Parameters that are only valid in range mode</p>
<ul>
<li><code v-pre>enableCross</code></li>
<li><code v-pre>minRange</code></li>
<li><code v-pre>maxRange</code></li>
<li><code v-pre>fixed</code></li>
</ul>
<h3 id="prohibit-slider-crossing"><a class="header-anchor" href="#prohibit-slider-crossing" aria-hidden="true">#</a> Prohibit slider crossing</h3>
<p><example :value="example1"></example></p>
<h3 id="limit-the-distance-between-the-sliders"><a class="header-anchor" href="#limit-the-distance-between-the-sliders" aria-hidden="true">#</a> Limit the distance between the sliders</h3>
<p><example :value="example2"></example></p>
</article></template>

<script>
  import examples from '@/examples/range.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>